import domReady from '@roots/sage/client/dom-ready';
import { initializeBlock } from '@scripts/initializeBlock';
import Litepicker from 'litepicker';

const initializeLitepicker = (block) => {
  const datePickerContainerDesktop = block.querySelector('.availability-form.desktop');
  const datePickerContainerMobile = block.querySelector('.availability-form.mobile');

  if (!datePickerContainerDesktop || !datePickerContainerMobile) return;

  // eslint-disable-next-line no-unused-vars
  const rangePicker = new Litepicker({
    element: block.querySelector('.availability-form.desktop #datepicker'),
    parentEl: block.querySelector('.availability-form.desktop #availabilityForm'),
    elementEnd: block.querySelector('.availability-form.desktop #checkOut'),
    firstDay: 1,
    format: 'D MMM, YYYY',
    lang: 'en-US',
    numberOfMonths: 2,
    numberOfColumns: 2,
    minDate: new Date(),
    maxDate: null,
    minDays: null,
    maxDays: null,
    selectForward: false,
    selectBackward: false,
    splitView: false,
    inlineMode: true,
    singleMode: false,
    autoApply: true,
    showWeekNumbers: false,
    showTooltip: true,
    disableWeekends: false,
    mobileFriendly: true,
    hotelMode: true,
    tooltipText: {
      one: 'night',
      other: 'nights',
    },
  });

  // eslint-disable-next-line no-unused-vars
  const rangePickerMobile = new Litepicker({
    element: block.querySelector('.availability-form.mobile #mobileDatepicker'),
    parentEl: block.querySelector('.availability-form.mobile #mobileAvailabilityForm'),
    elementEnd: block.querySelector('.availability-form.mobile #mobileCheckOut'),
    firstDay: 1,
    format: 'D MMM, YYYY',
    lang: 'en-US',
    numberOfMonths: 1,
    numberOfColumns: 1,
    minDate: new Date(),
    maxDate: null,
    minDays: null,
    maxDays: null,
    selectForward: false,
    selectBackward: false,
    splitView: false,
    inlineMode: true,
    singleMode: false,
    autoApply: true,
    showWeekNumbers: false,
    showTooltip: true,
    disableWeekends: false,
    mobileFriendly: true,
    hotelMode: true,
    tooltipText: {
      one: 'night',
      other: 'nights',
    },
  });
};

/**
 * Dom ready
 */
domReady(async () => {
  initializeBlock('.wp-block-single-availability-picker', initializeLitepicker);
});
